const VAST_EVENT_NAMES = {
  IMPRESSION: 'impression',
  START: 'start',
  FIRST_QUARTILE: 'firstQuartile',
  MIDPOINT: 'midpoint',
  THIRD_QUARTILE: 'thirdQuartile',
  COMPLETE: 'complete',
};

const AD_EVENT_NAMES = {
  AD_0_PERCENT: 'AD_0_PERCENT',
  AD_25_PERCENT: 'AD_25_PERCENT',
  AD_50_PERCENT: 'AD_50_PERCENT',
  AD_75_PERCENT: 'AD_75_PERCENT',
  AD_100_PERCENT: 'AD_100_PERCENT',
};

const AD_POD_EVENT_NAMES = {
  AD_POD_0_PERCENT: 'AD_POD_0_PERCENT',
  AD_POD_100_PERCENT: 'AD_POD_100_PERCENT',
};

const AD_TYPE = {
  AD: 'creative',
  INTERSTITIAL: 'interstitial',
  FILLER: 'filler',
};

export { VAST_EVENT_NAMES, AD_EVENT_NAMES, AD_POD_EVENT_NAMES, AD_TYPE };
